import dynamic from 'next/dynamic'

export const DynamicBuyAgainFilterModal = dynamic(
  () => import('.').then((mod) => mod.BuyAgainFilterModal),
  { ssr: false },
)
